<template>
  <div
    v-if="!isLoadingAsyncData"
    class="ViewLKProfileIndex"
  >
    <LKProfilePersonalData
      :profile="profile"
      :info="info"
      :permissions="permissions"
      @change="onProfileChange"
    >
      <template #actions>
        <UsersActionsList
          :user_id="profile.id"
        />
      </template>
    </LKProfilePersonalData>
  </div>
</template>

<script>
import { LKProfileMapper } from './store'
import LKProfilePersonalData from './components/LKProfilePersonalData.vue'
import UsersActionsList from '@/views/UsersActions/UsersActionsList.vue'


export default {
  name: 'ViewLKProfileIndex',
  components: {
    LKProfilePersonalData,
    UsersActionsList,
  },
  data: () => ({
    isLoadingAsyncData: false,
  }),
  computed: {
    ...LKProfileMapper.mapState([
      'profile',
      'info',
      'permissions',
    ]),
  },
  methods: {
    ...LKProfileMapper.mapActions([
      'getCurrent',
      'getPermissions',
    ]),

    asyncData() {
      const actions = [
        this.getCurrent(),
        this.getPermissions(),
      ]

      return Promise.all(actions)
    },

    async onProfileChange() {
      await this.getCurrent()
    },
  },
}
</script>

<style lang="scss">
.ViewLKProfileIndex {
  padding: 1px 40px 40px;
  background-color: $webflow-color-white;
}
</style>
